import { FreeHtmlTextSectionView } from "@cma/presentation-generation-logic/models/section-view";
import { useContentHydration } from "./useContentHydration";
import { AIAssistedTextSectionView } from "@cma/presentation-generation-logic/sections/ai-assisted-text/ai-assisted-text-section-view";
import { PresentationSectionViewProps } from "../PresentationSectionProps";
import { Container, FreeTextHtmlContent } from "./FreeHtmlText.styles";

interface Props
  extends PresentationSectionViewProps<
    FreeHtmlTextSectionView | AIAssistedTextSectionView
  > {}

export const FreeHtmlTextView = (props: Props) => {
  const {
    sectionView: { id, htmlContent },
  } = props;
  const { contentRef } = useContentHydration([htmlContent]);

  return (
    <Container id={id} $isEditing={false}>
      <FreeTextHtmlContent
        ref={contentRef}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </Container>
  );
};
